import React from 'react';
import PdfViewerPage from '../components/PdfViewerPage';

const PdfViewerPageContainer = () => {
  return <PdfViewerPage />;
};

export default PdfViewerPageContainer;
